import {css} from '@emotion/react';

export const mixinFocusWithBeforeContent = css`
  position: relative;
  box-shadow: none;

  &::before {
    content: ' ';
    position: absolute;
    border: var(--focus-border-width) solid var(--color-core-keyboardfocus);
    border-radius: 2px;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export const mixinFocus = css`
  border-radius: var(--focus-border-radius);
  border-color: var(--color-core-keyboardfocus);
  box-shadow: 0 0 0 var(--focus-border-width) var(--color-core-keyboardfocus);
`;

export const mixinRoundFocus = css`
  border-radius: 50%;
  border-color: var(--color-core-keyboardfocus);
  box-shadow: 0 0 0 2px var(--color-core-keyboardfocus);
`;

export const mixinFocusError = css`
  border-radius: var(--focus-border-radius);
  border-color: var(--color-alerts-error);
  box-shadow: 0 0 0 var(--focus-border-width) var(--color-alerts-error);
`;

export const mixinTopRowWrapper = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 900px;
`;

export const mixinFlexboxRow = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const mixinFlexboxColumn = css`
  display: flex;
  flex-direction: column;
`;

export const mixinFlexCenter = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const mixinUploadHighlight = css`
  outline: var(--gutter-tiny) var(--color-menu-border-focus) dashed;
  outline-offset: calc(-1 * var(--gutter-small));
`;

export const mixinHeading = css`
  color: var(--color-core-primary);
  font-size: var(--font-size-title);
  font-weight: var(--font-weight-title);
`;

export const mixinSubHeading = css`
  color: var(--color-core-primary);
  font-size: var(--font-size-subtitle);
  font-weight: var(--font-weight-subtitle);
`;

export const mixinParagraphHeading = css`
  font-size: var(--font-size-paragraph-title);
  font-weight: var(--font-weight-paragraph-title);
  color: var(--color-core-primary);
`;

export const mixinTruncate = css`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const mixinSVGIconLarge = css`
  width: var(--icon-large-dimension);
  height: var(--icon-large-dimension);
  fill: currentColor;
  flex-shrink: 0; // ensure that the icon does not shrink
`;

export const mixinSVGIcon = css`
  width: var(--icon-dimension);
  height: var(--icon-dimension);
  fill: currentColor;
  flex-shrink: 0; // ensure that the icon does not shrink
`;

export const mixinSVGIconTiny = css`
  width: var(--icon-tiny-dimension);
  height: var(--icon-tiny-dimension);
  fill: currentColor;
  flex-shrink: 0; // ensure that the icon does not shrink
`;

export const mixinSVGIconSmall = css`
  width: var(--icon-small-dimension);
  height: var(--icon-small-dimension);
  fill: currentColor;
  flex-shrink: 0; // ensure that the icon does not shrink
`;

export const mixinSVGIconMedium = css`
  width: var(--icon-medium-dimension);
  height: var(--icon-medium-dimension);
  fill: currentColor;
  flex-shrink: 0; // ensure that the icon does not shrink
`;

export const mixinCenterWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

// <editor-fold desc="Inputs">
const mixinInput = css`
  width: 100%;
  padding: var(--input-padding);
  border-radius: var(--button-border-radius);
  font-weight: var(--font-weight-thin);
`;

export const mixinInputValid = css`
  ${mixinInput};
  border: var(--regular-border-width) solid var(--color-core-dark-grey);

  :focus {
    ${mixinFocus}
  }
`;

export const mixinInputError = css`
  ${mixinInput};
  border: var(--regular-border-width) solid var(--color-alerts-error);

  :focus {
    ${mixinFocusError}
  }
`;

export const mixinInputDisabled = css`
  background-color: var(--color-core-grey-light);
  color: var(--input-color-disabled);
`;
// </editor-fold>

export const mixinUnstyledButton = css`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  outline: inherit;
`;

export const mixinOverflow = css`
  overflow: auto;
  overflow: overlay;
`;

export const mixinOverflowY = css`
  overflow-y: auto;
  overflow-y: overlay;
`;

export const mixinOverflowYWithGutter = css`
  ${mixinOverflowY};
  overflow-x: hidden; // needed for Firefox
  scrollbar-gutter: stable;
`;

export const mixinFloatingSideBar = css`
  ${mixinFlexboxColumn}
  width: var(--side-bar-width);
  height: calc(100vh - var(--header-height));
  min-height: calc(var(--application-height-min) - var(--header-height));
  border-left: var(--regular-border-width) solid var(--color-core-primary);
  background-color: var(--color-core-white);
  position: absolute;
  right: 0;
  top: 100%;
  z-index: var(--zindex-notification-center);
`;

export const mixinCursorPointer = css`
  cursor: pointer;
`;

export const mixinValidationErrorMessage = css`
  color: var(--color-validation-error);
  font-size: var(--font-size-tiny);
`;
